import { RdiErrorStatus } from './rdiTypes';

export const rdiErrorLabels: Record<RdiErrorStatus, string> = {
  [RdiErrorStatus.MISSING_CANDIDATE]: 'Données incohérentes avec le type de dossier, veuillez contacter le support.',
  [RdiErrorStatus.TECHNICAL_ERROR]:
    'Le service est actuellement indisponible ou le délai de réponse est trop long. Merci de bien vouloir réessayer ultérieurement.',
  [RdiErrorStatus.MISSING_OUTLET]: 'Aucun résultat trouvé, veuillez vérifier le code détaillant.',
};
